import { render, staticRenderFns } from "./RegisterModuleCustomization.vue?vue&type=template&id=33927044&scoped=true&"
import script from "./RegisterModuleCustomization.vue?vue&type=script&lang=js&"
export * from "./RegisterModuleCustomization.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModuleCustomization.vue?vue&type=style&index=0&id=33927044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33927044",
  null
  
)

export default component.exports